import { render, staticRenderFns } from "./preview-component-risk-assessment.vue?vue&type=template&id=37e36654&scoped=true&"
import script from "./preview-component-risk-assessment.vue?vue&type=script&lang=js&"
export * from "./preview-component-risk-assessment.vue?vue&type=script&lang=js&"
import style0 from "./preview-component-risk-assessment.vue?vue&type=style&index=0&id=37e36654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e36654",
  null
  
)

export default component.exports